import { useModuleBEM, useFlightStyles } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type InputErrorType,
} from "@b2bportal/core-types";
import { DatePickerButton, useFlightDateSelection } from "@tenant/flights";
import defaultStyles from "./FlightDateSelection.module.scss";

export type FlightDateSelectionProps = {
  setCalendarVisitedHandler?: () => void;
  closePopupHandler?: () => void;
  disabled?: boolean;
  selectedDepartureDate?: string;
  selectedReturnDate?: string;
  index?: number;
  error?: InputErrorType;
};

export const FlightDateSelection = (props: FlightDateSelectionProps) => {
  const styles = useFlightStyles(
    CoreFlightsComponent.FlightDateSelection,
    defaultStyles
  );

  const [, cn] = useModuleBEM(styles, CoreFlightsComponent.FlightDateSelection);

  const { context, handlers } = useFlightDateSelection(props);

  return (
    <DatePickerButton
      classes={[cn("container")]}
      buttonClass={cn("button")}
      error={props.error}
      {...context}
      {...handlers}
    />
  );
};
